export default "__VITE_ASSET__Bm7FJ06o__"